<template>
  <div class="school-year pos-relative"
       :class="{'white-theme': whiteTheme}"
       v-on-clickaway="clickaway">
    <div class="school-year__active pointer"
         :class="{'isActive': showDropdown}"
         @click="showDropdown = !showDropdown"
         v-if="schoolYears.length > 1">
      <p>{{activeSchoolYear.name}}</p>
      <span class="icon-arrow-down4"></span>
    </div>
    <div v-else
         class="school-year__active">
      <p>{{activeSchoolYear.name}}</p>
    </div>
    <transition name="dropdown">
      <div class="school-year__active__dropdown" v-show="showDropdown">
        <ul>
          <li v-for="year in schoolYears" @click="setActiveSchoolYear(year.id)">{{year.name}}</li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
  import {mixin as clickaway} from 'vue-clickaway'

  export default {
    mixins: [clickaway],
    props: {
      whiteTheme: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        showDropdown: false
      }
    },
    computed: {
      schoolYears () {
        return this.$store.state.activeSchoolYears
      },
      activeSchoolYear () {
        return this.$store.state.localActivatedSchoolYear
      }
    },
    watch: {
      activeSchoolYear (val) {
        this.$emit('yearChange', val)
      }
    },
    methods: {
      setActiveSchoolYear (schoolYearId) {
        this.showDropdown = false
        this.$store.commit('setlocalActivatedSchoolYear', schoolYearId)
      },
      clickaway () {
        if (!this.showDropdown) {
          return
        }
        this.showDropdown = false
      }
    }
  }
</script>

<style scoped>
  @import '../../assets/css/variables.css';

  .school-year__active {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    border-radius: 3px;
    color: #ffffff;
    margin: 0 auto;
    height: 26px;
    font-size: 11px;
    justify-content: space-between;
    background: rgba(255, 255, 255, 0.2);
    font-weight: bold;
    user-select: none;
    transition: background-color .15s, color 0.15s;
  }

  .school-year__active > span {
    margin-left: 10px;
  }

  .school-year__active.isActive {
    color: var(--blue);
    background: rgba(255, 255, 255, 1);
    border-radius: 3px 3px 0 0;
  }

  .school-year__active__dropdown {
    position: absolute;
    top: calc(100% + 1px);
    right: 0;
    left: 0;
    background-color: white;
    z-index: 100000;
    border-radius: 0 0 3px 3px;
    user-select: none;
    font-size: 11px;
  }

  .school-year__active__dropdown li {
    cursor: pointer;
    font-weight: bold;
    padding: 5px 10px;
    color: var(--dark-blue);
    width: 100%;
    text-align: left;
    margin: 0;
  }

  .school-year__active__dropdown li:last-child {
    border-radius: 0 0 3px 3px;
  }

  .school-year__active__dropdown li:hover {
    background-color: #f6f7f8;
    color: var(--blue);
  }

  .dropdown-enter-active, .dropdown-leave-active {
    transition: all .15s ease;
    transform: scaleY(1);
    transform-origin: top;
    overflow: hidden;
  }

  .dropdown-enter, .dropdown-leave-active {
    transform: scaleY(0);
    opacity: 0;
  }

  .white-theme .school-year__active {
    border: 1px solid #ccc;
    background: white;
    color: var(--dark-blue);
  }

  .white-theme .school-year__active.isActive {
    color: var(--blue);
  }

  .white-theme .school-year__active__dropdown {
    box-shadow: 0 8px 17px 2px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
  }


</style>



// WEBPACK FOOTER //
// ChangeSchoolYear.vue?81229fca